import { render, staticRenderFns } from "./yingShouDetil.vue?vue&type=template&id=2b0d7935&scoped=true&"
import script from "./yingShouDetil.vue?vue&type=script&lang=js&"
export * from "./yingShouDetil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d7935",
  null
  
)

export default component.exports